/**
 * Скрытие дублей ФИО в «Отчёт активности локальных ПК».
 * Несколько Windows-логинов (разный регистр / хвост DOMAIN\\user) могут
 * отображаться как одно и то же кириллическое ФИО.
 */

export function normalizeFioKey(name) {
  return String(name || '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Оценить «полноту» строки: больше отработанных минут и наличие деталей.
 * @param {object} item — элемент localReportRows
 * @param {Record<string, {hasScreenshots?: boolean, hasApplications?: boolean}>} [detailsAvailability]
 */
export function localReportRowScore(item, detailsAvailability = {}) {
  const avail = detailsAvailability[item?.key] || {};
  const worked = Number(item?.worked) || 0;
  const shots = avail.hasScreenshots ? 100000 : 0;
  const apps = avail.hasApplications ? 50000 : 0;
  const hasTime = item?.first && item?.last ? 1000 : 0;
  return worked + shots + apps + hasTime;
}

/**
 * Оставить по одной строке на уникальное отображаемое ФИО (лучшая по score).
 * Исходный массив не мутируется; нумерация i обновляется.
 */
export function hideDuplicateFioRows(rows, detailsAvailability = {}) {
  const list = Array.isArray(rows) ? rows : [];
  const bestByFio = new Map();
  for (const item of list) {
    const key = normalizeFioKey(item?.name);
    if (!key) {
      // без имени — оставляем как есть под уникальным ключом
      bestByFio.set(`__anon__${item?.key || Math.random()}`, item);
      continue;
    }
    const prev = bestByFio.get(key);
    if (!prev || localReportRowScore(item, detailsAvailability) > localReportRowScore(prev, detailsAvailability)) {
      bestByFio.set(key, item);
    }
  }
  return Array.from(bestByFio.values()).map((item, idx) => ({ ...item, i: idx + 1 }));
}

/** Сколько строк скрыто как дубли ФИО. */
export function countHiddenFioDuplicates(rows) {
  const list = Array.isArray(rows) ? rows : [];
  const keys = new Set();
  let dups = 0;
  for (const item of list) {
    const key = normalizeFioKey(item?.name);
    if (!key) continue;
    if (keys.has(key)) dups += 1;
    else keys.add(key);
  }
  return dups;
}
